<template>
  <div>
    <DataTable :className="tableClassName" :headers="headers" :items="items" @delete="deleteItem" />
    <div :class="className">
      <v-row dense>
        <v-col cols="12" md="8"
          ><BaseInput
            v-model="name"
            fieldName="name"
            :errors="nameErrors"
            :placeholder="inputPlaceholder"
            @change="onNameChange"
            @blur="$v.name.$touch()"
        /></v-col>
        <v-col cols="12" :md="this.place === 'checkout' ? 4 : 2">
          <YearPicker v-model="year" :height="47" @change="onYearChange" />
        </v-col>
        <v-col cols="12" :md="this.place === 'checkout' ? 12 : 2">
          <OutlinedButton
            :fullWidth="this.place === 'checkout'"
            :text="buttonText"
            size="large"
            @onClick="addItem"
            additionalClassName="outlined-btn__green"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import shortid from "shortid";
import { required } from "vuelidate/lib/validators";

import DataTable from "@/components/shared/DataTable";
import YearPicker from "@/components/shared/YearPicker";
import BaseInput from "@/components/uikit/BaseInput";
import OutlinedButton from "@/components/uikit/OutlinedButton";

export default {
  name: "PatientHistoryTable",
  props: ["items", "place", "id", "tableClassName"],
  components: {
    DataTable,
    YearPicker,
    BaseInput,
    OutlinedButton,
  },
  data: () => ({
    name: "",
    year: null,
  }),
  validations: {
    name: { required },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required && errors.push(this.inputRequiredText);
      return errors;
    },
    buttonText() {
      return this.id === "PMH" ? this.$t("visits.medical.addPMH") : this.$t("visits.medical.addPSH");
    },
    inputPlaceholder() {
      return this.id === "PMH" ? this.$t("visits.medical.PMHPlaceholder") : this.$t("visits.medical.PSHPlaceholder");
    },
    inputRequiredText() {
      const field = this.id === "PMH" ? this.$t("visits.medical.pastIllness") : this.$t("visits.medical.pastSurgeon");
      return this.$t("validation.required", { field });
    },
    className() {
      return this.place === "checkout" ? "ph-table_request-visit" : "ph-table_visit-notes";
    },
    headers() {
      return [
        {
          text: this.id === "PMH" ? this.$t("visits.summary.pmh") : this.$t("visits.summary.psh"),
          value: "name",
          width: "70%",
        },
        {
          text: this.$t("general.calendar.year"),
          value: "year",
          width: "25%",
        },
        { text: "", value: "action", width: "5%", align: "right" },
      ];
    },
  },
  methods: {
    onNameChange(value) {
      this.name = value;
    },
    onYearChange(value) {
      this.year = value;
    },
    deleteItem(id) {
      const newItems = this.items.filter((i) => i.id !== id);
      this.$emit("change", newItems);
    },
    addItem() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let newItems = [];
      if (this.items) {
        newItems = this.items.concat([
          {
            id: shortid.generate(),
            name: this.name.trim(),
            year: this.year,
          },
        ]);
      } else {
        newItems = [
          {
            id: shortid.generate(),
            name: this.name.trim(),
            year: this.year,
          },
        ];
      }
      this.name = "";
      this.year = "";
      this.$v.$reset();
      this.$emit("change", newItems);
    },
  },
};
</script>
